export enum RewriteStatus {
  RewriteNeeded = 'RewriteNeeded',
  RewriteCompleted = 'RewriteCompleted',
  RewriteWentInError = 'RewriteWentInError',
  RewriteInsightsReceived = 'RewriteInsightsReceived',
}

export const RewriteInProgressStatuses = [
  RewriteStatus.RewriteNeeded,
  RewriteStatus.RewriteInsightsReceived,
];
